exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tab-content[_v-24817285]{padding-left:20px}.admin-background-shadow[_v-24817285]{background:#f4f4f8}section[_v-24817285]{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-24817285&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/Admin/Admin-products-edit.vue
// module id = 412
// module chunks = 0